var React = require('react');

function De (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fc0","d":"M0 320h640v160H0z","key":0}),React.createElement("path",{"fill":"#000001","d":"M0 0h640v160H0z","key":1}),React.createElement("path",{"fill":"red","d":"M0 160h640v160H0z","key":2})]);
}

De.defaultProps = {"id":"flag-icons-de","viewBox":"0 0 640 480"};

module.exports = De;

De.default = De;
